function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "clipboard_path"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "clipboard_mask"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#clipboard_path"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "clipboard-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "clipboard-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clipboard_mask)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.1796875 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.10938 3.16406C2.10938 3.75476 1.64538 4.21875 1.05469 4.21875C0.463992 4.21875 0 3.75476 0 3.16406L0 1.05469C0 0.463992 0.463992 0 1.05469 0C1.64538 0 2.10938 0.463992 2.10938 1.05469L2.10938 3.16406Z",
  transform: "translate(27.421875 4.21875)",
  id: "Vector",
  fill: "#4D6699",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0C0.590695 0 1.05469 0.463992 1.05469 1.05469L1.05469 3.16406C1.05469 3.75476 0.590695 4.21875 0 4.21875L0 0Z",
  transform: "translate(28.476562 4.21875)",
  id: "Vector",
  fill: "#404B80",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.10938 3.16406C2.10938 3.75476 1.64538 4.21875 1.05469 4.21875C0.463992 4.21875 0 3.75476 0 3.16406L0 1.05469C0 0.463992 0.463992 0 1.05469 0C1.64538 0 2.10938 0.463992 2.10938 1.05469L2.10938 3.16406Z",
  transform: "translate(27.421875 31.78125)",
  id: "Vector",
  fill: "#4D6699",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 3.16406C1.05469 3.75476 0.590695 4.21875 0 4.21875L0 0C0.590695 0 1.05469 0.463992 1.05469 1.05469L1.05469 3.16406Z",
  transform: "translate(28.476562 31.78125)",
  id: "Vector",
  fill: "#404B80",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.10938 3.16406C2.10938 3.75476 1.64538 4.21875 1.05469 4.21875C0.463992 4.21875 0 3.75476 0 3.16406L0 1.05469C0 0.463992 0.463992 0 1.05469 0C1.64538 0 2.10938 0.463992 2.10938 1.05469L2.10938 3.16406Z",
  transform: "translate(10.546875 0)",
  id: "Vector",
  fill: "#4D6699",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 3.16406C1.05469 3.75476 0.590695 4.21875 0 4.21875L0 0C0.590695 0 1.05469 0.463992 1.05469 1.05469L1.05469 3.16406Z",
  transform: "translate(11.6015625 0)",
  id: "Vector",
  fill: "#404B80",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6016 0L1.05469 0C0.471727 0 0 0.471727 0 1.05469L0 30.7266C0 31.3095 0.471727 31.7813 1.05469 31.7813L11.6016 31.7813L22.1484 31.7813C22.7314 31.7813 23.2031 31.3095 23.2031 30.7266L23.2031 1.05469C23.2031 0.471727 22.7314 0 22.1484 0L11.6016 0Z",
  transform: "translate(0 4.21875)",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6016 1.05469C11.6016 0.471727 11.1298 0 10.5469 0L0 0L0 31.7813L10.5469 31.7813C11.1298 31.7813 11.6016 31.3095 11.6016 30.7266L11.6016 1.05469Z",
  transform: "translate(11.6015625 4.21875)",
  id: "Vector",
  fill: "#2F42B0",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0187 0L9.49219 0L7.97119 0L6.32813 1.05469L0 1.05469L0 28.6172L9.49219 28.6172L18.9844 28.6172L18.9844 1.05469L12.6563 1.05469L11.0187 0Z",
  transform: "translate(2.109375 5.2734375)",
  id: "Vector",
  fill: "#F9F4F3",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.16406 1.05469L1.52655 0L0 0L0 28.6172L9.49219 28.6172L9.49219 1.05469L3.16406 1.05469Z",
  transform: "translate(11.6015625 5.2734375)",
  id: "Vector",
  fill: "#F0E6E1",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.78309 1.80037C5.19505 1.38841 5.19505 0.720932 4.78309 0.308971C4.37113 -0.10299 3.70365 -0.10299 3.29169 0.308971L2.54603 1.05464L1.80037 0.308971C1.38841 -0.10299 0.720931 -0.10299 0.30897 0.308971C-0.10299 0.720932 -0.10299 1.38841 0.30897 1.80037L1.05463 2.54603L0.30897 3.2917C-0.10299 3.70366 -0.10299 4.37114 0.30897 4.7831C0.720931 5.19506 1.38834 5.19513 1.80037 4.7831L2.54603 4.03743L3.29169 4.7831C3.70365 5.19506 4.37106 5.19513 4.78309 4.7831C5.19505 4.37114 5.19505 3.70366 4.78309 3.2917L4.03743 2.54603L4.78309 1.80037Z",
  transform: "translate(4.836914 26.000732)",
  id: "Vector",
  fill: "#FF6673",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(12.65625 14.8359375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.471727 2.10938 0 1.63765 0 1.05469C0 0.471727 0.471727 0 1.05469 0L3.16406 0C3.74702 0 4.21875 0.471727 4.21875 1.05469C4.21875 1.63765 3.74702 2.10938 3.16406 2.10938L1.05469 2.10938Z",
  transform: "translate(2.109375 0)",
  id: "Vector",
  fill: "#B3CCFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.471727 2.10938 0 1.63765 0 1.05469C0 0.471727 0.471727 0 1.05469 0L5.27344 0C5.8564 0 6.32813 0.471727 6.32813 1.05469C6.32813 1.63765 5.8564 2.10938 5.27344 2.10938L1.05469 2.10938Z",
  transform: "translate(0 6.328125)",
  id: "Vector",
  fill: "#B3CCFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 2.10938C0.471727 2.10938 0 1.63765 0 1.05469C0 0.471727 0.471727 0 1.05469 0L5.27344 0C5.8564 0 6.32813 0.471727 6.32813 1.05469C6.32813 1.63765 5.8564 2.10938 5.27344 2.10938L1.05469 2.10938Z",
  transform: "translate(0 12.65625)",
  id: "Vector",
  fill: "#B3CCFF",
  fillRule: "evenodd",
  stroke: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0L0 2.54609L0.745661 1.80042C1.15769 1.38839 1.15769 0.720985 0.745661 0.309024L0.745661 0.309024C0.539646 0.103008 0.269788 0 0 0Z",
  transform: "translate(11.6015625 10.6171875)",
  id: "Vector",
  fill: "#48B348",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0L0 2.54609L0.745661 1.80042C1.15769 1.38839 1.15769 0.720985 0.745661 0.309024L0.745661 0.309024C0.539646 0.103008 0.269788 0 0 0Z",
  transform: "translate(11.6015625 16.945312)",
  id: "Vector",
  fill: "#48B348",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.21875 0L2.10938 0C0.944367 0 0 0.944367 0 2.10938L0 3.16406C0 3.74653 0.472219 4.21875 1.05469 4.21875L4.21875 4.21875L7.38281 4.21875C7.96528 4.21875 8.4375 3.74653 8.4375 3.16406L8.4375 2.10938C8.4375 0.944367 7.49313 0 6.32813 0L4.21875 0Z",
  transform: "translate(7.3828125 2.109375)",
  id: "Vector",
  fill: "#4D6699",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.21875 2.10938C4.21875 0.944367 3.27438 0 2.10938 0L0 0L0 4.21875L3.16406 4.21875C3.74653 4.21875 4.21875 3.74653 4.21875 3.16406L4.21875 2.10938Z",
  transform: "translate(11.6015625 2.109375)",
  id: "Vector",
  fill: "#404B80",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.32813 9.6821C6.32813 11.8547 5.44226 14.0344 3.90227 15.5741C3.7125 15.7852 3.43828 15.8906 3.16406 15.8906C2.88984 15.8906 2.61563 15.7852 2.42585 15.5741C0.885868 14.0344 0 11.8547 0 9.6821L0 1.05469L2.10938 0L4.21875 0L6.32813 1.05469L6.32813 9.6821Z",
  transform: "translate(25.3125 18)",
  id: "Vector",
  fill: "#CDE2FF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.16406 9.6821C3.16406 11.8547 2.27819 14.0344 0.73821 15.5741C0.548437 15.7852 0.274219 15.8906 0 15.8906L0 0L1.05469 0L3.16406 1.05469L3.16406 9.6821Z",
  transform: "translate(28.476562 18)",
  id: "Vector",
  fill: "#B3CCFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.32813 10.6172L4.21875 11.6719L2.10938 11.6719L0 10.6172L0 3.23438C0 1.48352 1.41321 0 3.16406 0C4.91491 0 6.32813 1.48352 6.32813 3.23438L6.32813 10.6172Z",
  transform: "translate(25.3125 6.328125)",
  id: "Vector",
  fill: "#CDE2FF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.16406 10.6172L1.05469 11.6719L0 11.6719L0 0C1.75085 0 3.16406 1.48352 3.16406 3.23438L3.16406 10.6172Z",
  transform: "translate(28.476562 6.328125)",
  id: "Vector",
  fill: "#B3CCFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.32813 0L6.32813 2.10938L0 2.10938L0 0L6.32813 0Z",
  transform: "translate(25.3125 16.945312)",
  id: "Vector",
  fill: "#4D6699",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.16408 6.32813C3.43387 6.32813 3.7038 6.22512 3.90974 6.0191L7.38283 2.54609L8.12849 1.80042C8.54045 1.38846 8.54045 0.720985 8.12849 0.309024C7.92248 0.103008 7.65262 0 7.38283 0C7.11304 0 6.84311 0.103008 6.63717 0.309024L3.16408 3.78204L1.80037 2.41833C1.38841 2.00637 0.720932 2.00637 0.308971 2.41833C-0.10299 2.83029 -0.10299 3.49777 0.308971 3.90973L2.41842 6.0191C2.62443 6.22512 2.89429 6.32813 3.16408 6.32813Z",
  transform: "translate(4.21875 10.6171875)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.63717 0.309024L3.16408 3.78204L1.80037 2.41833C1.38841 2.00637 0.720932 2.00637 0.308971 2.41833C-0.10299 2.83029 -0.10299 3.49777 0.308971 3.90973L2.41835 6.0191C2.62436 6.22512 2.89422 6.32813 3.16401 6.32813C3.4338 6.32813 3.70373 6.22512 3.90967 6.0191L7.38283 2.54609L8.12849 1.80042C8.54045 1.38846 8.54045 0.720985 8.12849 0.309024C7.92255 0.103008 7.65269 0 7.38283 0L7.38283 0C7.11297 0 6.84311 0.103008 6.63717 0.309024Z",
  transform: "translate(4.21875 16.945312)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.16406 0L3.16406 2.10938L0 2.10938L0 0L3.16406 0Z",
  transform: "translate(28.476562 16.945312)",
  id: "Vector",
  fill: "#404B80",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.192c1696.svg";
export { ForwardRef as ReactComponent };